import Bugsnag from '@bugsnag/js';
import getConfig from 'next/config';
import { useQuery } from 'react-query';
import { doctorProfileService } from 'services';

import { ServerStateKeysEnum } from '../constants';

export const useDoctorProfile = () => {
  return useQuery(
    ServerStateKeysEnum.doctorProfile,
    doctorProfileService.getDoctorProfile,
    {
      staleTime: Infinity,
      onSuccess: data => {
        const { publicRuntimeConfig } = getConfig();
        const gccInstanceUrl = publicRuntimeConfig.GCC_INSTANCE_URL;
        const countriesToRedirectToGCC =
          publicRuntimeConfig.COUNTRY_LIST_TO_REDIRECT_GCC_INSTANCE;

        // Redirect IL and TR doctors to GCC store.
        if (
          countriesToRedirectToGCC.includes(data?.country) &&
          publicRuntimeConfig.STORE_REGION === 'EMEA'
        ) {
          window.location.href = gccInstanceUrl;
        }

        Bugsnag.setUser(data.did, data.userName, data.firstName);
      },
    }
  );
};
